<ng-container *ngIf="pageData">
  
  <div class="tabcontainer pageEditor">
   
    <div class="formStory fl100" [ngStyle]="setStoryHeight()" #formStory>
      <ul class="storyuL">
        <li>
          <ul class='container' [dragula]="'element-bag'" [dragulaModel]='viewPortItems'>
            <li *ngFor="let elementId of viewPortItems;let i = index">
              <ng-container *ngIf="elementId !== hideElementId">
                <div #elReferenc class="element-module" [id]="elementId"
                  [preLoadedcardData]="serveElementContent(elementId)"
                  (updateContentOnParent)="getUpadtedElementContent($event)"
                  (cardDataFromElement)="getCardDatafromElement($event)" (removeSavedCardData)="removeSaved($event)"
                  [cardId]="elementId" [EditMode]="storyEditMode" [editCardFlag]="storyEditMode"
                  (deleteCardfn)="deleteCardEmit($event)" (childKeyDown)="childKeyDownEventCatcher($event)"
                  (currentcardfn)="currentCardId($event)" (sendWordCountToStory)="getWordCount($event)"
                  (lastindexfn)="lastParaIndex($event)" [storyElementArray]="pageData.bodyElements" [isPage]="true">
                  <!--(incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
              (scrollOut)="scr($event)" [storyId]="id" (embedChangeOutput)="checkForSourceUrlInEmbed($event)" [modelSuggestion]="modelSuggestion" [brandSuggestion]="brandSuggestion"
              [storytype]="storyType" (paraContentChanged)="onParaContentChanged($event)" [disableEditPara]="disableEditPara"
              (manualLinkCountIncr)="manualAutoBacklinkCountIncr()"
              (manualLinkCountDecr)="manualAutoBacklinkCountDecr()"
              (emitParentPaywallIdDelete)="deletePaywallElement()"
              (emitEnableDisableSampleImagePopup)="enableDisableSampleImagePopup($event)"
              (emitRefereshStory) = "refereshStory($event)"
              (previousFocusEmit)="focusOnElement($event, 'up')"
              (nextFocusEmit)="focusOnElement($event, 'down')" (changeRelated)="getRelatedStoryEmits($event)" (changeRelatedHowto)="getRelatedStoryEmitsHowto($event)"
              (updateCardDatafn)="receiveCardData($event)" (emitParaDeleteContent)="mergeParaWithUpper($event)" (afterInitializeEmit)="removeTempCardView($event)"-->
                </div>
              </ng-container>
            </li>
          </ul>
        </li>
        <li class='container' *ngIf="storyEditMode && showTempPara">
          <div #newElement class="element-module" [id]="'newElement'" [cardId]="tempCardData ? tempCardData.id : null"
            [EditMode]="storyEditMode" [editCardFlag]="storyEditMode" [editCardId]="currentcardId"
            (deleteCardfn)="deleteCardEmit($event)" (childKeyDown)="childKeyDownEventCatcher($event)"
            (updateContentOnParent)="getUpadtedElementContent($event)" (currentcardfn)="currentCardId($event)"
            (sendWordCountToStory)="getWordCount($event)" (lastindexfn)="lastParaIndex($event)"
            (tempParaSaveEmit)="getTempParaSavedId($event)" (deleteTempViewOfPara)="showElementOfTempPara($event)"
            [storyElementArray]="pageData.bodyElements" [isPage]="true" (deleteTempParafn)="deleteTempParaEmit($event)">
            <!--(incrementPendingRequest)="increasePendingCount()" (decrementPendingRequest)="decreasePendingCount($event)"
      (scrollOut)="scr($event)" [storytype]="storyType" (cardDataFromElement)="getCardDatafromElement($event)"
      (removeSavedCardData)="removeSaved($event)" (previousFocusEmit)="focusOnElement($event, 'up')"
      (nextFocusEmit)="focusOnElement($event, 'down')" (emitParaDeleteContent)="mergeParaWithUpper($event)"
      [preLoadedcardData]="tempCardData" -->
          </div>
        </li>
      </ul>

      <div>
        <div class="story_icons">
          <ul class="para_icons">
           <!--  <li class="para_icon" (click)="addParaAtLast()">
             
              <span class="tooltip">Insert Para at last 1</span>
            </li>-->
            <li  class="para_icon" (click)="addParaAtLast()">
              <i  class="icon-para" id=""></i>
              <span  class="tooltip">Insert Para at last</span>
              </li>
            <!-- <li class="font_icon spImg_story"></li> -->
            <li class="image_icon" (click)="openInlineImageOption('image')" #toolbarInlineImage>
              <i class="icon-image" id="buttonInsertImage"></i><span class="tooltip">Insert Image</span>
              <div [class]="'imageAction' +  (inlineImageToggle ? ' block' : '') ">
                <div class="blockContain">
                  <div class="uploadimage">
                    <i class="icon-upload"></i>
                    <div class="upload-btn-wrapper">
                      <span class="btn">Upload new File</span>
                      <ng-container *ngIf="!sharedService.isdomainConfig('story','multipleInlineImage')">
                        <input type="file" name="myfile" accept="image/*"
                          (change)="onInlineFileChange($event, 'elements')" />
                      </ng-container>
                      <ng-container *ngIf="sharedService.isdomainConfig('story','multipleInlineImage')">
                        <input #uploadGalleryId tabindex="0" type="file" accept="image/*" name="myfile"
                          (change)="multipleInlineUpload($event, 'elements')" multiple />
                      </ng-container>
                    </div>
                  </div>
                  <div class="pickimage">
                    <i class="icon-image-library"></i>
                    <span (click)="addInlineImage()" class="pickimageBtn">Pick from Image Library</span>
                  </div>
                </div>
              </div>
            </li>

            <li class="embed_icon" (click)="isButtonDisabled() ? showMessage('Embed') : openEmbedPopup('elements')">
              <i class="icon-embed" id="buttonInsertEmbed"></i>
              <span class="tooltip">Insert Embed</span>
            </li>

            <li class="video_icon" (click)="isButtonDisabled() ? showMessage('Video') : showVideoGallery('elements')">
              <i class="icon-video" id="buttonInsertVideo"></i>
              <span class="tooltip">Insert Video</span>
            </li>

            <ng-container *ngIf="(isTableEnabled());then tablOptions else tableOption"></ng-container>

            <ng-template #tablOptions>

              <li class="table_icon spImg_story" (click)="openInlineImageOption('table')" #toolbarTable>
                <i class="icon-table"></i>
                <span class="tooltip">Insert Table</span>
                <div [class]="'tableSelect' +  (inlineTableToggle ? ' block' : '') ">
                  <div class="tableDropBlock">
                    <div class="tableInsert">
                      <span (click)="isButtonDisabled() ? showMessage('Table') : createNewTable('elements')">Insert
                        Table</span>
                    </div>
                    <div class="tableLibrary">
                      <span (click)="openElementModal('table')">Pick from Library</span>
                    </div>
                  </div>
                </div>
              </li>
            </ng-template>
            <ng-template #tableOption>
              <li *ngIf="domainConfig.elementsDisabled.indexOf('Embed') === -1" class="table_icon spImg_story"
                (click)="createNewTable('elements')">
                <i class="icon-table"></i>
                <span class="tooltip">Insert Table</span>
              </li>

            </ng-template>



            <li class="faq_icon spImg_story1" *ngIf="domainConfig.elementsDisabled.indexOf('faq') === -1"
              (click)="isButtonDisabled() ? showMessage('Faqs') : openFaqPopup()">
              <span class="tooltip">Insert Faq</span>
            </li>

            <li class="faq_icon listing_icon" *ngIf="domainConfig.elementsDisabled.indexOf('listicleElement') === -1"
            (click)="insertListingElement('elements')">
               <span class="tooltip">Insert Listing</span>
            </li>

            <li class="related_icon spImg_story"
                (click)="isButtonDisabled() ? showMessage('Also Reas') : openRelatedStoryModal('Also Read','single')" id="buttonRelatedStory">
                  <span class="tooltip">Insert Also Read</span>
            </li>
            <li class="label_icon faq_icon " *ngIf="domainConfig.elementsDisabled.indexOf('label') === -1"
            (click)="isButtonDisabled() ? showMessage('label') : openLabelPopup()">
               <span class="tooltip">Insert label</span>
            </li>
            <li class="separator_icon faq_icon " *ngIf="domainConfig.elementsDisabled.indexOf('separator') === -1"
            (click)="isButtonDisabled() ? showMessage('Separator') : openSeparatorPopup()">
               <span class="tooltip">Insert Separator</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div [class]="inlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
    <div class="headerLight">
      <div class="close fl spImg" (click)="disableInlineImage()"></div>
    </div>
    <ng-container *ngIf="sharedService.isdomainConfig('story','multipleInlineImage')">
      <div class="photo-listing" [photogalleryId]="true" (emitIdfn)="addMultipleInlineImages($event)"
        *ngIf="inlineImageFlag"></div>
    </ng-container>
    <ng-container *ngIf="!sharedService.isdomainConfig('story','multipleInlineImage')">
      <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addInlineImageEmit($event)"
        *ngIf="inlineImageFlag"></div>
    </ng-container>
  </div>

  <ng-container *ngIf="showLoader">
    <div class="imagepreloader">
      <div class="a" style="--n: 5;">
        <div class="dot dot1" style="--i: 0;"></div>
        <div class="dot dot2" style="--i: 1;"></div>
        <div class="dot dot3" style="--i: 2;"></div>
        <div class="dot dot4" style="--i: 3;"></div>
      </div>
    </div>
  </ng-container>

  <div class="lightBox embeddblock block" *ngIf="embedPopup">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Add Embed</h3>
        <ng-container>
          <label>{{getEmbedPopupTitle()}}</label>
          <textarea type="text" id="inputAddEmbedUrl" class="textBox" [(ngModel)]="embedCode"
            placeholder="Enter for the Facebook, tweet, etc here…" tabindex="0"></textarea>
          <label>Source URL</label>
          <textarea type="text" id="inputAddEmbedSourceUrl" class="textBoxSmall" [(ngModel)]="embedSourceUrl"
            placeholder="Enter Source url here" tabindex="0"></textarea>
          <label>Subtype</label>
          <textarea type="text" class="textBoxSmall" [(ngModel)]="embedSubType" placeholder="Enter Subtype here"
            tabindex="0"></textarea>
        </ng-container>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="closeEmbedPopup()"
          class="cancel gray ml10">Cancel</button>
        <button type="button" id="buttonSubmitEmbed" tabindex="0" name="unlock" (click)="saveEmbed()"
          class="add blue ml10 ">Done</button>
      </div>
    </div>
  </div>

  <div class="lightBox block lightBoxVideo" *ngIf="isLightboxVideo">
    <div class="headerLight">
      <div class="close fl spImg" (click)="disableshowVideoGallery()"></div>
    </div>
    <div class="lightContent">
      <div class="headingPage">
        <ng-container *ngIf="enableJW === 'true'">
          <h2 class="tablinks all_stories" (click)="showJW = true;showYT = false" [class]="showJW ? 'active' : ' '"
            id="defaultOpen">JW Videos</h2>
        </ng-container>
        <ng-container *ngIf="enableYT">
          <h2 class="tablinks my_workspace" (click)="showJW = false;showYT = true" [class]="showYT ? 'active' : ' '"
            id="wire">Youtube Videos</h2>
        </ng-container>
      </div>
      <ng-container *ngIf="showJW">
        <div class="listing" pageId="videoStory" allApi="video_stories" searchApi="video_search" videoListing="true"
          [showPagination]="true" [videogallery]="true" metaApi="" (sendIdVieoToParentfn)="getLeadMediaVideo($event)"
          search_label="Search Videos...">
        </div>
      </ng-container>
      <ng-container *ngIf="showYT">
        <youtube-listing (sendIdVieoToParentfn)="getLeadMediaVideo($event)"></youtube-listing>
      </ng-container>
    </div>
  </div>

  <div class="lightBox cropimagelightbox block" *ngIf="tablePopup">
    <div class="unlockStory">
      <div class="wid100">
        <h3 class=" pad30">Table</h3>
        <div class="cropimageblock pad30">
          <div class="cropAspectRatio">
            <ckeditor [editor]="ckEditorTable" [(ngModel)]="tableHTML" [config]="tableConfig"
              (ready)="ckchanges($event, 'ready', 'table')" (change)="ckchanges($event, 'change', 'table')"></ckeditor>
          </div>
        </div>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" name="cancel" (click)="closeTable()" class="cancel gray ml10">Cancel</button>
        <button type="button" name="unlock" (click)="changeTable()" class='add blue ml10'>Done</button>
      </div>
    </div>
  </div>

  <div class="lightBox listrelatedstories listTableElements listingFour block" *ngIf="tableReusablePopup">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closeElementModal(null)"></div>
    </div>
    <div class="element-listing" (elementSelection)="addElementToStory($event)" [elementType]="'table'"
      (closePopupEmit)="closeElementModal($event)" [chooseMultiple]="false"></div>
  </div>


  <div class="lightBox faqblock block" *ngIf="showFaqPopup">
    <div class="unlockStory">
      <div class="wid100">
        <h3 class="pad30">Add FAQs</h3><span class="shortCutsKeyPopup">(<i>Press cmd+k/ctrl+k for hyperlink</i>)</span>
        <form [formGroup]="tempFaqData">
          <li>
            <div class="headingBlock">
              <label>Heading of the FAQ section<span>(Max. 100 characters)</span></label>
              <div class="dataField">
                <textarea maxlength="100" class="textBoxSmall" formControlName="heading" placeholder="Enter the heading"
                  tabindex="0" type="text"></textarea>
                <span class="requiredField" *ngIf="tempFaqData.get('heading').touched && !tempFaqData.get('heading').valid &&
              tempFaqData.get('heading').errors?.required">Heading is required</span>
              </div>
            </div>
          </li>
          <div class="faqQueAnsw">
            <ng-container formArrayName="faqs" *ngFor="let faq of tempFaqData.get('faqs').controls; let i = index;">
              <div class="faqBlockQue">
                <i *ngIf="tempFaqData.get('faqs').controls.length > 1" class="icon-delete" (click)="deleteFaq(i)"></i>
                <ng-container [formGroupName]="i">

                  <li>
                    <div class="">
                      <label>Question {{i+1}}
                        <!-- <span>(Max. 100 characters)</span> -->
                      </label>
                      <div class="dataField">
                        <textarea class="textBoxSmall" formControlName="key" placeholder="Enter the question"
                          type="text"></textarea>
                        <span class="requiredField" *ngIf="tempFaqData.get('faqs')['controls'][i].get('key').touched && !tempFaqData.get('faqs')['controls'][i].get('key').valid &&
                    tempFaqData.get('faqs')['controls'][i].get('key').errors?.required">Question is required</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="answer">
                      <label>Answer {{i+1}}
                        <!-- <span>(Max. 500 characters)</span> -->
                      </label>

                      <ckeditor [editor]="ckEditorFAQ" [config]="faqConfig" formControlName="value"
                        placeholder="Enter the answer"></ckeditor>
                      <span class="requiredField" *ngIf="tempFaqData.get('faqs')['controls'][i].get('value').touched && !tempFaqData.get('faqs')['controls'][i].get('value').valid &&
                    tempFaqData.get('faqs')['controls'][i].get('value').errors?.required">Answer is required</span>

                    </div>
                  </li>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </form>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="addFaq()" class="cancel btnFaq">+ Add another
          QnA</button>
        <button type="button" tabindex="0" name="cancel" (click)="closeFaqPopup()"
          class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" class="add blue ml10 " (click)="saveFaqs()">Done</button>
      </div>
    </div>
  </div>

  <div class="lightBox faqblock block" *ngIf="showLabelPopup">
    <div class="unlockStory">
      <div class="wid100">
        <h3 class="pad30">Add Label</h3>
          <li>
            <div class="headingBlock">
              <label>Add Label<span>(Max. 100 characters)</span></label>
              <div class="dataField">
                <textarea maxlength="100" [(ngModel)]="label" class="textBox"  placeholder="Enter label"
                  tabindex="0" type="text"></textarea>
              </div>
            </div>
          </li>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="closeLabelPopup()"
          class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" class="add blue ml10 " (click)="saveLabel()">Done</button>
      </div>
    </div>
  </div>
  <div class="lightBox faqblock block" *ngIf="showSeparatorPopup">
    <div class="unlockStory">
      <div class="wid100">
        <h3 class="pad30">Add Separator</h3>
          <li>
            <div class="headingBlock">
              <label>Add Height<span style="color: rgb(185, 50, 50);">(Only Numbers)</span></label>
              <div class="dataField">
                <textarea maxlength="100" [(ngModel)]="separator" class="textBoxSmall" placeholder="Enter Height"
                  tabindex="0" (keypress)="numberOnly($event)"></textarea>
              </div>
            </div>
          </li>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="closeSepartorPopup()"
          class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" class="add blue ml10 " (click)="saveSeparator()">Done</button>
      </div>
    </div>
  </div>

  <div class="lightBox listicle-element-popup block" *ngIf="showListiclePopup" style="z-index: 10 !important;">
    <div class="unlockStory">
      <div class="wid100">
        <h3 class="pad30">Add List</h3>
        <form [formGroup]="tempListicleData" class="formListicleCss" >
          <li>
            <div class="headingBlock">
            <label>Heading</label>
            <div class="dataField">
                <textarea appTextareaAutoresize class="textBoxSmall" formControlName="heading" placeholder="Enter the heading" tabindex="0" type="text"></textarea>
            </div>
            <div style="margin-top: 2%;">
              <span class="listicle-element">
                Bullet Type
              </span>
              <input type="radio" id="yes" name="fav_language" formControlName = "listicleBulletType" name="listicleBulletType" [checked]="true" value="number" class="margin-left">
             <span class="listicle-element">Numbered</span>
             <input type="radio" id="no" name="fav_language" formControlName = "listicleBulletType" name="listicleBulletType" value="bullet"  style="margin-left: 2%;">
             <span class="listicle-element">Bulleted</span>
              <input type="radio" id="no" name="fav_language" formControlName = "listicleBulletType" name="listicleBulletType" value="border" style="margin-left: 2%;">
             <span class="listicle-element">Bordered</span>
            </div>
          </div>
          </li>
          <div class="faqQueAnsw" style="overflow-y: none;">
            <ng-container formArrayName="listicleArray"
                *ngFor="let faq of tempListicleData.get('listicleArray').controls; let i = index;">
              <div class="listBlockQue">
                <i *ngIf="tempListicleData.get('listicleArray').controls.length > 1" class="listElement icon-delete" (click)="deleteListicle(i)"></i>
              <ng-container [formGroupName]="i">
                  <li>
                    <div class="">
                    <label>Listicle Title {{i+1}}
                    </label>
                    <div class="dataField">
                        <textarea appTextareaAutoresize class="textBoxSmall" formControlName="key" placeholder="Enter the title" type="text"></textarea>
                    </div>
                  </div>
                  </li>
                  <li>
                    <div class="answer">
                    <label>Listicle Content {{i+1}}
                    </label>
                    <div class="dataField">
                      <textarea appTextareaAutoresize class="textBoxSmall" formControlName="value" placeholder="Enter the content" type="text"></textarea>
                  </div>
                  </div>
                  </li>
                  <ng-container *ngIf="enableUrlInListicle">
                  <li>
                    <div class="answer">
                    <label>Listicle Url {{i+1}}
                    </label>
                    <div class="dataField">
                      <textarea appTextareaAutoresize class="textBoxSmall" formControlName="url" placeholder="Enter the url" type="text"></textarea>
                  </div>
                  </div>
                  </li>
                  </ng-container>
                  <label>Listicle Media {{i+1}}</label>
                  <div *ngIf="tempListicleData === undefined || (tempListicleData.get('listicleArray')['controls'][i].get('media').value === null)" >
                    <i class="icon-image" style="color:#888888" (click)="addListicleImage(i,target)"></i>
                    <i class="icon-video listicle-icon" (click)="showVideoGallery('listicleMedia',i)"></i>
                    <i class="icon-embed listicle-icon" (click)="showListcleEmbed(i)"></i>
                  </div>
                  <ng-container *ngIf="imageLoaderShow && tempListicleData.get('listicleArray')['controls'][i].get('media').value === null && i===videoIndex">
                    <div class="imagepreloader">
                      <div class="a" style="--n: 5;top: 92%">
                        <div class="dot dot1" style="--i: 0;"></div>
                        <div class="dot dot2" style="--i: 1;"></div>
                        <div class="dot dot3" style="--i: 2;"></div>
                        <div class="dot dot4" style="--i: 3;"></div>
                      </div>
                    </div>
                  </ng-container>
                  <i class="icon-delete media-delete-icon" *ngIf="tempListicleData.get('listicleArray')['controls'][i].get('media').value !== null" (click)="deleteListicleMedia(i)"></i>
                  <ng-container *ngIf="enableListicleImageOption && tempListicleData.get('listicleArray')['controls'][i].get('media').value === null && i===videoIndex">
                    <div class="dataField pad30">
                      <div class="stepsDropBlock-listicle">
                        <div class="imageInsert-listicle" (click)="updateCurrentHowToStep(i)">
                          <span>Upload from file</span>
                          <input type="file" name="myfile" accept="image/*" (change)="onFileChangeSingle($event, 'listicleUploadImage')" />
                        </div>
                        <div class="imageLibrary-listicle" (click)="addListicleInlineImage()">
                          <span>Pick from Library</span>
                        </div>
                        </div>
                    </div>
                  </ng-container>
                  <div *ngIf="tempListicleData.get('listicleArray')['controls'][i].get('mediaType').value === 'video'&&tempListicleData.get('listicleArray')['controls'][i].get('media').value !== null" class="respVideo" [innerHtml]="tempListicleData.get('listicleArray')['controls'][i].get('media').value.video.body | noSanitize">
                  </div>
                  <div #embedEl>
                  <div *ngIf="tempListicleData.get('listicleArray')['controls'][i].get('mediaType').value === 'embed' && tempListicleData.get('listicleArray')['controls'][i].get('media').value !== null" [innerHtml]="tempListicleData.get('listicleArray')['controls'][i].get('media').value.embedCode | noSanitize">
                  </div> </div>
                  <div *ngIf="tempListicleData.get('listicleArray')['controls'][i].get('mediaType').value === 'image' && tempListicleData.get('listicleArray')['controls'][i].get('media').value !== null">
                    <img width="300px" src="{{tempListicleData.get('listicleArray')['controls'][i].get('media').value.image.images.original}}" (load)="onImageLoad()">
                  </div>
              </ng-container>

            </div>
            </ng-container>
            <div #target>
            </div>
          </div>
        </form>
      
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="addListicle(target)" class="cancel btnFaq">+ Add another list</button>
        <button type="button" tabindex="0" name="cancel" (click)="closeListiclePopup()" class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" class="add blue ml10 " [disabled]="!imageLoaded"
         (click)="saveListicleElement()">Done</button>
      </div>
    </div>
  </div>
  <div class="lightBox stepblock block" *ngIf="showEmbedForListcleElement" style="z-index: 10 !important;">
    <div class="unlockStory">
      <div class="wid100 pad30">
        <h3>Add Embed</h3>
        <textarea type="text" id="inputAddEmbedUrl" class="textBox" [(ngModel)]="listicleEmbedCode" placeholder="Enter for the Facebook, tweet, etc here…"
        tabindex="0"></textarea>
      </div>
      <div class="fr wid100 right padlr30 ptb15">
        <button type="button" tabindex="0" name="cancel" (click)="closeListicleEmbedPopup()" class="cancel gray ml10">Cancel</button>
        <button type="button" tabindex="0" name="unlock" (click)="saveEmbedData()" class="add blue ml10 ">Add</button>
      </div>
    </div>
  </div>

  <div class="lightBox storyVersion inlineImage block" *ngIf="showDefaultImageSelector">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closeImageSelector()"></div>
    </div>
    <div class="">
      <div class="lightContent padding3050">
        <div class="">
          <h3>Uploaded image is of Low Quality, please choose default image to upload.</h3>
          <div class="custom_image">
           <ul>
            <ng-container *ngFor="let defaultImage of defaultImages; let i =index">
              <li>
                <img  alt="" [src]="defaultImage">
                <button type="button" name="choose" class="cancel customBtn " (click)="chooseThisImage(defaultImage)">Choose</button>
               </li>
            </ng-container>
             
          </ul>
          <div class="clearBoth"></div>
          </div>

          <div class=" wid100 right  clearBoth">
            
            <button type="button" name="cancel"  (click)="closeImageSelector()" class="add blue" >Cancel</button>
            <div class="clearBoth"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

    <div [class]="listicleInlineImageFlag ? 'lightBox photogallerylist inlineImage block' : 'lightBox'">
      <div class="headerLight">
        <div class="close fl spImg" (click)="disabledListicleImageMedia()"></div>
      </div>
      <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="addStepsInlineImageEmit($event, 'listicleUploadImage')" *ngIf="listicleInlineImageFlag"></div>
    </div>

    <div [class]="showAlsoReadStoryPopup ? 'lightBox listrelatedstories block' : 'lightBox'">
      <div class="headerLight">
        <div class="close fl spImg" (click)="closeRelatedStoryModal(null)"></div>
      </div>
      <div class="related-story-listing" [chooseMultiple]="relatedStoryMultipleSelectFlag"
        (closePopupEmit)="closeRelatedStoryModal($event)" (sendIdListToParentfn)="getAlsoReadId($event)" (sendAlsoReadData)="getAlsoReadIds($event)" *ngIf="showAlsoReadStoryPopup" [relatedStoryType]="relatedStoryType"></div>
    </div>
</ng-container>